import { AxiosRequestConfig } from 'axios';
import { HttpResponse, ajax } from '../../../../common/ajax';
import { config } from '../../config';
import { DiscoverProductsModel } from '../../models/Discover';
import { ProductListModel } from '../../models/Product';

interface IDiscoverService {
  getProducts: (
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<DiscoverProductsModel[]>>;
  getProductsForCategory: (
    categoryId: number,
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<ProductListModel[]>>;
  getTitleById: (
    categoryId: number,
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<string>>;
  getProductsIn: (
    location: string,
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<ProductListModel[]>>;
}

export const discoverService: IDiscoverService = {
  getProducts(axiosConfig) {
    return ajax.get<DiscoverProductsModel[]>(
      `${config.benefitApiUrl}/discover`,
      axiosConfig,
    );
  },
  getProductsForCategory(categoryId, axiosConfig) {
    return ajax.get<ProductListModel[]>(
      `${config.benefitApiUrl}/discover/${categoryId}`,
      axiosConfig,
    );
  },
  getTitleById(categoryId, axiosConfig) {
    return ajax.get<string>(
      `${config.benefitApiUrl}/discover/${categoryId}/title`,
      axiosConfig,
    );
  },
  getProductsIn(location, axiosConfig) {
    return ajax.get<ProductListModel[]>(
      `${config.benefitApiUrl}/discover/in/${location}`,
      axiosConfig,
    );
  },
};
